const OCTOCOM_SESSION_TOKEN_KEY = 'octocom:data:sessionToken';
const OCTOCOM_SESSION_SCOPE_KEY = 'octocom-session-scope';
const OCTOCOM_AUTH_STATUS_KEY = 'octocom-auth-status';
const CLEAR_OCTOCOM_HISTORY_EVENT_NAME = 'clearOctocomHistory';

export const updateOctocomSession = (isLoggedIn: boolean) => {
    const previousStatus = window.localStorage.getItem(OCTOCOM_AUTH_STATUS_KEY);
    const existingScope = window.localStorage.getItem(OCTOCOM_SESSION_SCOPE_KEY);
    const existingToken = window.localStorage.getItem(OCTOCOM_SESSION_TOKEN_KEY);
    const nextStatus = isLoggedIn ? 'authenticated' : 'anonymous';
    // Before auth status was stored separately, anonymous scopes used the logged-out prefix.
    const isLegacyAuthenticatedSession =
        previousStatus === null && (existingScope ? !existingScope.startsWith('logged-out-') : !!existingToken);
    const shouldClearSession = !isLoggedIn && (previousStatus === 'authenticated' || isLegacyAuthenticatedSession);

    if (shouldClearSession) {
        window.localStorage.removeItem(OCTOCOM_SESSION_TOKEN_KEY);
        window.localStorage.setItem(OCTOCOM_SESSION_SCOPE_KEY, crypto.randomUUID());
    } else if (!existingScope) {
        window.localStorage.setItem(OCTOCOM_SESSION_SCOPE_KEY, crypto.randomUUID());
    }

    window.localStorage.setItem(OCTOCOM_AUTH_STATUS_KEY, nextStatus);

    if (shouldClearSession) {
        window.dispatchEvent(new Event(CLEAR_OCTOCOM_HISTORY_EVENT_NAME));
    }
};
